import {NgModule} from '@angular/core';

import {RowComponent} from './row.component';

@NgModule({
  declarations: [RowComponent],
  exports: [RowComponent],
})
export class RowModule {}
